import debounce from 'lodash.debounce';

/**
 * @description Название события изменения значений полей формы.
 * @type {string}
 */
const NAME_EVENT_CHANGE_FIELD_VALUES = 'change-values';

/**
 * @description Время задержки проверки обновления полей.
 */
const WAIT_TIME = 300;

/**
 * @description Примесь значащих полей формы.
 */
export default {
  computed: {
    /**
     * @description Значимые поля.
     * @type {any}
     */
    meaningfulFields: () => null,
  },
  created() {
    this.initialHashFieldValues = this.getHashMeaningfulFields(this.meaningfulFields);
    this.$emit(NAME_EVENT_CHANGE_FIELD_VALUES, this.$options.name, false);
  },
  data() {
    return {
      /**
       * @description Начальный хэш.
       * @type {string}
       */
      initialHashFieldValues: '',
    };
  },
  methods: {
    /**
     * @description Получить хэш.
     * @param {any} fields Поля.
     * @returns {string}
     */
    getHashMeaningfulFields(fields) {
      const json = JSON.stringify(fields);
      return json;
    },
  },
  watch: {
    meaningfulFields: debounce(function update(fields) {
      const hash = this.getHashMeaningfulFields(fields);
      const isChange = hash !== this.initialHashFieldValues;
      this.$emit(NAME_EVENT_CHANGE_FIELD_VALUES, this.$options.name, isChange);
    }, WAIT_TIME),
  },
};
